// External libraries
import { useRecoilValue } from 'recoil';

// Components
import { userCurrencyState } from "../states";

// Utilities
import { useFetchWrapper } from '../helpers';
import { APIS } from '../constants';


const useStoriesService = () => {
    const fetchWrapper = useFetchWrapper();
    const selCurrency = useRecoilValue(userCurrencyState);

    function getAllStories(paginationData: { geo_code: number, page_no: number, storiespp: number, sort_by?: string, reverse?: string }) {
        const queryString = Object.entries(paginationData)
            .map(([key, value]) => `${key.replaceAll('_', '-')}=${value}`)
            .join('&');
        const url = `${APIS.STORIES.GET_ALL_STORIES}?${queryString}&currency=${selCurrency}`;
        return fetchWrapper.get(url);
    }

    return {
        getAllStories,
    }
}
export { useStoriesService };
